import React from 'react';
import { Box, TextField } from '@mui/material';

const EventFormatSection = ({ 
    eventDetails, 
    handleChange, 
    isEditing, 
}) => {
    return (
        <Box>
            <TextField
                fullWidth
                margin="normal"
                label="Agenda Overview"
                value={eventDetails.event?.agenda || ''}
                onChange={(e) =>
                    handleChange(
                        'agenda',
                        e.target.value
                    )
                }
                disabled={!isEditing}
                multiline
                rows={3}
            />
            <TextField
                fullWidth
                margin="normal"
                label="Key Activities"
                value={eventDetails.event?.keyActivities || ''}
                onChange={(e) =>
                    handleChange(
                        'keyActivities',
                        e.target.value
                    )
                }
                disabled={!isEditing}
                multiline
                rows={3}
            />
            <TextField
                fullWidth
                margin="normal"
                label="Special Features"
                value={eventDetails.event?.specialFeatures || ''}
                onChange={(e) =>
                    handleChange(
                        'specialFeatures',
                        e.target.value
                    )
                }
                disabled={!isEditing}
                multiline
                rows={3}
            />
        </Box>
    );
};

export default EventFormatSection;